export class ShopTheLook extends HTMLElement {
  constructor() {
    super();

    this.singleProductForms = this.querySelectorAll('form[data-single-option]');
    this.multipleProductForms = this.querySelectorAll('form[data-multiple-options]');
    this.totalPrice = 0;
    this.productCount = 0;
    this.addToCartButtons = this.querySelectorAll('.atc_shop_the_look');

    this.init();
  }

  init() {
    this.addListeners();

    document.querySelector('.shop-the-look-link').addEventListener('click', () => {
      const element = this;
      const headerOffset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.scrollY - headerOffset;
    
      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
      });
    });
  }

  addListeners() {
    this.singleProductForms.forEach((form) => {
      form.querySelectorAll('.js-stl-add-icon').forEach((icon) => {
        icon.addEventListener('click', () => {
          icon.closest('.product-item__image').querySelector('.product-item__options').classList.add('is-open');
        });
      });

      form.querySelectorAll('.arrow-right-scroll').forEach((icon) => {
        icon.addEventListener('click', () => {
          icon.closest('.product-item__options').querySelector('.sizes-container').scrollBy({
            left: 100,
            behavior: 'smooth'
          });
        });
      });
      
      form.querySelectorAll('.arrow-left-scroll').forEach((icon) => {
        icon.addEventListener('click', () => {
          icon.closest('.product-item__options').querySelector('.sizes-container').scrollBy({
            left: -100,
            behavior: 'smooth'
          });
        });
      });

      this.checkOverflow(form);
      this.addInputChangeListeners(form);
    });

    this.multipleProductForms.forEach((form) => {
      form.querySelectorAll('.js-variants input').forEach((input) => {
        input.addEventListener('change', () => {
          form.dataset.selectedId = input.value;
        });
      });

      form.querySelectorAll('.js-stl-add-icon').forEach((icon) => {
        icon.addEventListener('click', () => {
          icon.closest('.product-item__image').querySelector('.product-item__options').classList.add('is-open');
        });
      });

      form.querySelectorAll('.arrow-right-scroll').forEach((icon) => {
        icon.addEventListener('click', () => {
          icon.closest('.arrows-container').nextElementSibling.scrollBy({
            left: 100,
            behavior: 'smooth'
          });
        });
      });
      
      form.querySelectorAll('.arrow-left-scroll').forEach((icon) => {
        icon.addEventListener('click', () => {
          icon.closest('.arrows-container').nextElementSibling.scrollBy({
            left: -100,
            behavior: 'smooth'
          });
        });
      });

      this.checkOverflow(form);
      this.addInputChangeListeners(form);
    });

    window.addEventListener('resize', () => {
      this.singleProductForms.forEach((form) => this.checkOverflow(form));
      this.multipleProductForms.forEach((form) => this.checkOverflow(form));
    });
    
    this.enableDragScroll();
    this.addToCartButtons.forEach(button => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        this.handleAddToCartButtonClick(event);
      });
    });
  }

  addInputChangeListeners(form) {
    const inputs = form.querySelectorAll('.size-container__items input[type="radio"]');
    inputs.forEach(input => {
      input.addEventListener('change', () => {
        this.checkFormInputs(form);
      });
    });
  }

  checkFormInputs(form) {
    const sizeContainers = form.querySelectorAll('.size-container__items');
    let allChecked = true;
    sizeContainers.forEach(container => {
      const selectedInput = container.querySelector('input[type="radio"]:checked');
      if (!selectedInput) {
        allChecked = false;
      }
    });

    const addToCartButton = form.querySelector('.atc_shop_the_look');
    if (allChecked) {
      addToCartButton.removeAttribute('disabled');
    } else {
      addToCartButton.setAttribute('disabled', 'true');
    }
  }

  checkOverflow(form) {
    const containers = form.querySelectorAll('.sizes-container');

    setTimeout(() => {
      containers.forEach((container, index) => {
        const content = container.querySelector('.size-container__items');
        const previousElement = container.previousElementSibling;
  
        if (content.scrollWidth > container.clientWidth) {
          if (previousElement) {
            previousElement.classList.remove('hidden');
          }
        } else {
          if (previousElement) {
            previousElement.classList.add('hidden');
          }
        }
      });
    }, 100);
  }

  enableDragScroll() {
    const containers = this.querySelectorAll('.sizes-container');
    containers.forEach(container => {
      let isDown = false;
      let startX;
      let scrollLeft;

      container.addEventListener('mousedown', (e) => {
        isDown = true;
        container.classList.add('active');
        startX = e.pageX - container.offsetLeft;
        scrollLeft = container.scrollLeft;
      });

      container.addEventListener('mouseleave', () => {
        isDown = false;
        container.classList.remove('active');
      });

      container.addEventListener('mouseup', () => {
        isDown = false;
        container.classList.remove('active');
      });

      container.addEventListener('mousemove', (e) => {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - container.offsetLeft;
        const walk = (x - startX) * 3; // Adjust scroll speed
        container.scrollLeft = scrollLeft - walk;
      });
    });
  }

  handleAddToCartButtonClick(event) {
    const button = event.target;
    const form = button.closest('form');
    if (form) {
      if (form.hasAttribute('data-single-option')) {
        const sizeContainers = form.querySelectorAll('.size-container__items');
        let allChecked = true;
        sizeContainers.forEach(container => {
          const selectedInput = container.querySelector('input[type="radio"]:checked');
          if (!selectedInput) {
            allChecked = false;
          }
        });

        if (allChecked) {
          const selectedInput = form.querySelector('.size-container__items input[type="radio"]:checked');
          if (selectedInput) {
            const variantId = selectedInput.value;
            this.addToCart(variantId, form);
          }
        } 
      } else if (form.hasAttribute('data-multiple-options')) {
        const sizeContainers = form.querySelectorAll('.size-container__items');
        let allChecked = true;
        const variantParts = [];
        sizeContainers.forEach(container => {
          const selectedInput = container.querySelector('input[type="radio"]:checked');
          if (selectedInput) {
            variantParts.push(selectedInput.value);
          } else {
            allChecked = false;
          }
        });

        if (allChecked) {
          const variant = variantParts.join('/');

          const variantElements = form.querySelectorAll('.js-variants');
          let matchingVariantElement = null;
          variantElements.forEach(variantElement => {
            const input = variantElement.querySelector('input[data-title]');
            if (input && input.getAttribute('data-title') === variant) {
              matchingVariantElement = variantElement;
            }
          });

          if (matchingVariantElement) {
            const variantId = matchingVariantElement.querySelector('input[data-title]').value;
            this.addToCart(variantId, form);
          }
        }
      }
    }
  }

  addToCart(variantId, form) {
    const itemData = {
      id: variantId, // ID of the variant to add to the cart
      quantity: 1
    };

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(itemData)
    })
    .then(response => response.json())
    .then(data => {
      console.log('Product added to cart:', data);
      this.updateIcons(form);
      this.openSideCart();
      this.closeProductOptions(form);
    })
    .catch(error => {
      console.error('Error adding product to cart:', error);
    });
  }

  updateIcons(form) {
    const addIcon = form.querySelector('.js-stl-add-icon');
    const checkIcon = form.querySelector('.js-stl-check-icon');
    if (addIcon && checkIcon) {
      addIcon.classList.add('hidden');
      checkIcon.classList.remove('hidden');
    }
  }

  closeProductOptions(form) {
    const productOptions = form.querySelector('.product-item__options');
    if (productOptions) {
      productOptions.classList.add('hidden');
      productOptions.classList.remove('is-open');
    }
  }

  openSideCart() {
    const waitForSmartCart = (callback) => {
      if (window?.Rebuy?.SmartCart) {
        callback(window.Rebuy.SmartCart);
      } else {
        const observer = new MutationObserver(() => {
          if (window?.Rebuy?.SmartCart) {
            observer.disconnect();
            callback(window.Rebuy.SmartCart);
          }
        });
        observer.observe(document, { childList: true, subtree: true });
      }
    };

    waitForSmartCart((SmartCart) => {
      SmartCart.show();
    });
  }
}

customElements.define('shop-the-look', ShopTheLook);